import React, { useEffect, useState } from "react";

import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import CustomTable from "../../../components/table/table";
import { admin_event_delete, admin_event_list } from "../admin.api";
import ManageEvent from "./manage/manage";
import "./view.css";
import jwtDecode from "jwt-decode";
import TextField from "../../../components/inputs/textfield";
import SearchButton from "../../../components/buttons/search/search-btn";

export default function View(props) {
  const defaultFormData = {
    // event_organized_type: "kspace",
    event_title_en: "",
    oraganized_by_en: "",
    event_date: "",
    location_en: "",
    registration_types: [
      {
        type: "",
        days: "",
        fees: "",
      },
    ],
  };

  const [data, setdata] = useState([]);
  const [view, setView] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [formData, setFormData] = useState(defaultFormData);
  const [edit, setEdit] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [activeData, setActiveData] = useState({});
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [search, setSearch] = useState("");
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  //console.log(jwtDecode(props.state.payload));
  const handleEventList = (search) => {
    setIsActive(true);
    admin_event_list(search).then((res) => {
      let tempData = res.data.filter(
        (item) => item.event_organized_type === "kspace"
      );
      tempData.forEach((item, index) => {
        item["slno"] = index + 1;
      });
      setdata(tempData);
      setIsActive(false);
    });
  };
  useEffect(() => {
    handleEventList();
  }, []);
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleEventList();
    }
  };
  const handleAddNew = (e, d) => {
    setAddNew(true);
    setFormData({ ...defaultFormData, event_organized_type: d });
    setView(false);
  };
  const handleClose = () => {
    setAddNew(false);
    setEdit(false);
    setFormData({});
    handleEventList();
  };
  const handleEdit = (data) => {
    setFormData(data);
    setView(false);
    setEdit(true);
    setAddNew(true);
  };
  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    admin_event_delete(data.uuid)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };
  const handleView = (data) => {
    let path = `/event-list/${data.uuid}`;
    props.history.push(path);
  };
  const handleClear = () => {
    setSearch("");
    handleEventList();
  };
  const handleSearch = () => {
    handleEventList(search);
  };
  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Kspace Events</b>
        </h6>
        <hr />
        {/* Admin */}
        {adminType === 1 && (
          <>
            <div className="d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-primary btn-sm mb-3"
                onClick={(e) => handleAddNew(e, "kspace")}
              >
                Add New
              </button>
              <div className="d-flex ">
                <div className=" ml-2 mr-2">
                  <TextField
                    id="outlined-basic"
                    name="search"
                    variant="outlined"
                    placeholder="Search Name"
                    value={search ?? "Search"}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <div className=" d-flex">
                  <SearchButton
                    {...props}
                    onClick={() => search && handleSearch()}
                  />
                  <div className="mx-2">
                    <div className="clearSearch" onClick={() => handleClear()}>
                      Clear Search
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <button
              type="button"
              className="btn btn-primary btn-sm mx-2"
              onClick={(e) => handleAddNew(e, "others")}
            >
              Add New Others Event
            </button> */}
            <CustomTable
              {...props}
              columns={[
                { title: "No", field: "slno", type: "dynId" },
                { title: "Image", type: "imageFull", field: "event_image" },
                { title: "Event Name", field: "event_title_en" },
                { title: "Organizer", field: "oraganized_by_en" },
                { title: "Date", field: "event_date", type: "date" },
                { title: "Venue", field: "location_en" },
                // { title: "Status", field: "status", type: "StatusType" },
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },
                // { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
        {/* superAdmin */}
        {adminType === 2 && (
          <>
            {" "}
            <CustomTable
              {...props}
              columns={[
                { title: "No", field: "slno", type: "dynId" },
                { title: "Image", type: "imageFull", field: "event_image" },
                { title: "Event Name", field: "event_title_en" },
                { title: "Organizer", field: "oraganized_by_en" },
                { title: "Date", field: "event_date", type: "date" },
                { title: "Venue", field: "location_en" },
                // { title: "Status", field: "status", type: "StatusType" },
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                // { type: "edit", handleClick: handleEdit },
                { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
        {/* inter-admin */}
        {(adminType === 3 || adminType === 23) && (
          <>
            <CustomTable
              {...props}
              columns={[
                { title: "No", field: "slno", type: "dynId" },
                { title: "Image", type: "imageFull", field: "event_image" },
                { title: "Event Name", field: "event_title_en" },
                { title: "Organizer", field: "oraganized_by_en" },
                { title: "Date", field: "event_date", type: "date" },
                { title: "Venue", field: "location_en" },
                // { title: "Status", field: "status", type: "StatusType" },
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                // { type: "edit", handleClick: handleEdit },
                // { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
      </div>
      {addNew && (
        <ManageEvent
          open={addNew}
          edit={edit}
          view={view}
          handleClose={handleClose}
          formData={formData}
        />
      )}
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Event ?"
          data={activeData}
          message="Are you sure to delete this Event?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </div>
  );
}
